/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Progress_StartingInputs */

const en_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting embed export...`)
};

const fr_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l'exportation intégrée...`)
};

const de_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einbettungs-Export wird gestartet...`)
};

const it_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'esportazione dell'incorporamento...`)
};

const ru_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта встраивания...`)
};

const es_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando la exportación de incrustaciones...`)
};

const zh_cn2_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始嵌入导出...`)
};

const ja_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込みエクスポートを開始しています...`)
};

const hi_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेड निर्यात शुरू हो रहा है...`)
};

const pt_pt2_audio_embed_export_progress_starting = /** @type {(inputs: Audio_Embed_Export_Progress_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação de conteúdo incorporado...`)
};

/**
* | output |
* | --- |
* | "Starting embed export..." |
*
* @param {Audio_Embed_Export_Progress_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_starting = /** @type {((inputs?: Audio_Embed_Export_Progress_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_progress_starting(inputs)
	if (locale === "de") return de_audio_embed_export_progress_starting(inputs)
	if (locale === "it") return it_audio_embed_export_progress_starting(inputs)
	if (locale === "ru") return ru_audio_embed_export_progress_starting(inputs)
	if (locale === "es") return es_audio_embed_export_progress_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_progress_starting(inputs)
	if (locale === "ja") return ja_audio_embed_export_progress_starting(inputs)
	if (locale === "hi") return hi_audio_embed_export_progress_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_progress_starting(inputs)
	return en_audio_embed_export_progress_starting(inputs)
});